import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {WfUserContainerModel} from '../../../../../../models/aggregates/crm/wf-user';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class WfUserService extends BaseApiTemplateService<WfUserContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + '/wf-users';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + '/wf-users';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + '/wf-users';
    this.httpClient = http;
  }

}


